// Polyfill global
(window as any).global = window;

export {};
